import React from "react";
import BCInformationForm from "../components/forms/BcInformationForm";

const ProjectInformation: React.FC = () => {
  return (
   <>
   <BCInformationForm />
   </>
  );
};

export default ProjectInformation;
